import styled from 'styled-components';
import { dataPointMappingLayoutStyles } from 'modules/settings/pods/settings-integrations/components';

export const DataPointMappingLayout = styled.div`
    ${dataPointMappingLayoutStyles}

    owc-input {
        & owc-assistive-text {
            color: var(--one-color-gray-500) !important;
        }
    }
`;
